import { actionTypes } from '../../constants';
import { fromJS } from 'immutable';

const {
  GET_TRANSACTION_LIST_SUCCESS,
  GET_TRANSACTION_LIST_FAILURE,
  SHOW_AMOUNT_BUTTON,
  CLOSE_POPUP,
  SHOW_ABROAD_POPUP,
  CLOSE_ABROAD_POPUP,
  OPEN_METHOD_POPUP,
  GET_INCOMING_TRANSACTION_SUCCESS,
  GET_INCOMING_TRANSACTION_FAILURE,
} = actionTypes;

export const initialState = fromJS({
  transactionRequestPacket: undefined,
  bulkTransactionAlerts: '',
  transactionError: false,
  showButton: false,
  incomingTransactionAlerts: '',
  incomingTransactionError: false,
  incomingTransactionRequestPacket: undefined,
  showAbroadPopup: false,
  showMethodAlertsMasterPopup: false,
});

// eslint-disable-next-line complexity
const bulkTransactionAlerts = (state = initialState, action) => {
  switch (action.type) {
    case GET_TRANSACTION_LIST_SUCCESS:
      return state.set('bulkTransactionAlerts', action.payload).set('transactionRequestPacket', '');
    case GET_TRANSACTION_LIST_FAILURE:
      return state
        .set('transactionError', action.error)
        .set('transactionRequestPacket', action.meta);
    case SHOW_AMOUNT_BUTTON:
      return state.set('showButton', action.isButtonOpen);
    case CLOSE_POPUP:
      return state
        .set('transactionError', action.isPopupClosed)
        .set('incomingTransactionError', action.isPopupClosed);
    case GET_INCOMING_TRANSACTION_SUCCESS:
      return state
        .set('incomingTransactionAlerts', action.payload)
        .set('incomingTransactionRequestPacket', '');
    case GET_INCOMING_TRANSACTION_FAILURE:
      return state
        .set('incomingTransactionError', action.error)
        .set('incomingTransactionRequestPacket', action.meta);
    case SHOW_ABROAD_POPUP:
      return state.set('showAbroadPopup', action.showAbroadPopup);
    case CLOSE_ABROAD_POPUP:
      return state.set('showAbroadPopup', action.closeAbroadPopup);
    case OPEN_METHOD_POPUP:
      return state.set('showMethodAlertsMasterPopup', action.showMethodAlertsMasterPopup);
    default:
      return state;
  }
};

export default bulkTransactionAlerts;
